import { render, staticRenderFns } from "./CompanyComparativeDataPanel.vue?vue&type=template&id=0ccc770c&scoped=true&"
import script from "./CompanyComparativeDataPanel.vue?vue&type=script&lang=js&"
export * from "./CompanyComparativeDataPanel.vue?vue&type=script&lang=js&"
import style0 from "./CompanyComparativeDataPanel.vue?vue&type=style&index=0&id=0ccc770c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccc770c",
  null
  
)

export default component.exports